var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('login-toggle',{on:{"loginUserType":_vm.setLoginUser}}),_vm._v(" "),(this.loginUserType == 'clinician')?_c('clinician-login'):_c('employer-login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }